import { tryParsePhoneNumber } from "../../../components/global_components/form_components/ControlledPhoneNumber";

export function compareIdentifiers(identifierA: string, identifierB: string, type: "Email" | "Phone" | "App"): boolean {
  switch (type) {
    case "Email":
      return identifierA.toLowerCase().trim() === identifierB.toLowerCase().trim();
    case "Phone":
      return tryParsePhoneNumber(identifierA).formats.e164 === tryParsePhoneNumber(identifierB).formats.e164;
    case "App":
      return identifierA.trim() === identifierB.trim();
    default:
      return false;
  }
}
